export default __webpack_public_path__ + "static/pr5-3420a1eb7b636c171c716c55d3a0ae8a.svg";